import React, {useEffect} from 'react'
import {
  getScheduleItemModalItem,
  isScheduleItemModalOpen,
  isFiltersModalOpen,
  isPersonalAgendaModalOpen,
  isLoginDrawerOpen,
} from '../../selectors/modals'
import {useWidgetProps} from '../../hooks/widget-props'
import {ScheduleItem} from './schedule-item'
import {FiltersModal} from './filters-modal/filters'
import {PersonalAgendaModal} from './personal-agenda/personal-agenda'
import {LoginDrawer} from './login-drawer'

export const Modals = () => {
  const {modals, host} = useWidgetProps()
  const filtersModalOpen = isFiltersModalOpen(modals)
  const personalAgendaModalOpen = isPersonalAgendaModalOpen(modals)
  const scheduleItemModalOpen = isScheduleItemModalOpen(modals)
  const loginDrawerOpen = isLoginDrawerOpen(modals)
  const anyModalOpen = filtersModalOpen || personalAgendaModalOpen || scheduleItemModalOpen || loginDrawerOpen

  useEffect(() => {
    if (anyModalOpen) {
      host?.blockScroll?.()
    } else {
      host?.unblockScroll?.()
    }

    return () => {
      host?.unblockScroll?.()
    }
  }, [anyModalOpen])

  return (
    <>
      {filtersModalOpen && <FiltersModal />}
      {personalAgendaModalOpen && <PersonalAgendaModal />}
      {scheduleItemModalOpen && <ScheduleItem item={getScheduleItemModalItem(modals)} />}
      {loginDrawerOpen ? <LoginDrawer /> : null}
    </>
  )
}
